export default "/static/dashboard/build/app/img/v2/80acb1ff0a43df630c82229cfb61df2a.png";